module.exports = __webpack_public_path__ + "img/02.61ba6838.png";